<div class="tw-flex tw-flex-col tw-gap-2 tw-w-full tw-h-full">
  <!--        select file-->
  <div class="tw-flex tw-w-full tw-min-h-0 tw-flex-1 tw-flex-col tw-gap-2">
    <!--          outer-->
    <form
      class="tw-h-full tw-w-full tw-cursor-pointer tw-rounded-xl tw-bg-dt-surface-elevated tw-p-2 tw-shadow-inner"
      [ngClass]="{
        'tw-border tw-border-solid tw-border-dt-border-error': errorMessage,
        '!tw-h-48 tw-resize-y tw-overflow-auto': currentFile,
      }"
      (click)="!currentFile && fileSelector.click()"
      (dragover)="onSuppress($event)"
      (dragleave)="onSuppress($event)"
      (drop)="onFileDrop($event)"
    >
      <input
        #fileSelector
        type="file"
        id="file"
        class="form-control-file"
        name="file"
        (change)="onFileUpload($event)"
        [accept]="fileTypeAllowed"
        [autofocus]="false"
        hidden
      />
      <!--  no more dot line -->
      <div
        class="tw-flex tw-h-full tw-flex-col tw-items-center tw-justify-center tw-rounded-lg tw-opacity-60"
      >
        <div
          *ngIf="fileName; else noFile"
          class="tw-h-full tw-w-full tw-rounded-xl tw-bg-dt-surface-card"
        >
          <!-- Mapped statement: show the mapped table. The raw, unmapped statement is never shown. -->
          <app-file-preview
            *ngIf="hasMapped"
            [data]="{ file: currentFile }"
            [mappedRows]="mappedRows"
            class="tw-h-full tw-w-full"
          ></app-file-preview>
          <!-- Non-tabular files (e.g. pdf) preview as-is. -->
          <app-file-preview
            *ngIf="!hasMapped && !isTabularFile"
            [data]="{ file: currentFile }"
            class="tw-h-full tw-w-full"
          ></app-file-preview>
          <!-- Tabular statement awaiting mapping: prompt instead of the raw grid. -->
          <div
            *ngIf="!hasMapped && isTabularFile"
            class="tw-flex tw-h-full tw-w-full tw-items-center tw-justify-center tw-p-4 tw-text-center tw-text-sm tw-text-dt-text-disabled"
          >
            {{ "statementSelectedMapPrompt" | i18n }}
          </div>
        </div>

        <ng-template #noFile>
          <div class="tw-flex tw-gap-2">
            <span class="tw-pointer-events-none tw-font-medium tw-underline tw-opacity-60">
              {{ "clickOrDragFile" | i18n }}
            </span>
            <icon [name]="'upload'" [size]="6" [currentColor]="'neutral-300'"></icon>
          </div>
        </ng-template>
      </div>
    </form>
  </div>

  <div class="tw-flex tw-w-full tw-items-center tw-justify-between">
    <div>
      @if (currentFile) {
        <div
          class="tw-flex tw-cursor-pointer tw-w-full tw-text-dt-text-headings"
          (click)="fileSelector.click()"
        >
          <span class="tw-whitespace-nowrap tw-overflow-hidden tw-text-ellipsis">{{
            fileName
          }}</span>
          @if (currentFile) {
            <button (click)="onRemoveClick($event)">x</button>
          }
        </div>
      }
      @if (!currentFile) {
        <span class="tw-pointer-events-none tw-opacity-60">{{ "fileUploadLimit" | i18n }}</span>
      }
      @if (errorMessage) {
        <span class="tw-text-dt-text-error">{{ errorMessage | i18n }}</span>
      }
    </div>
    <div class="tw-flex tw-gap-2">
      <button
        *ngIf="fileName"
        type="button"
        class="tw-cursor-pointer tw-items-center tw-justify-center tw-rounded-lg tw-bg-dt-surface-elevated tw-px-3 tw-py-2.5 tw-text-dt-text-headings tw-shadow-button"
        (click)="replaceFile()"
      >
        {{ "replaceFile" | i18n }}
      </button>
      <button
        *ngIf="fileName"
        type="button"
        class="tw-cursor-pointer tw-items-center tw-justify-center tw-rounded-lg tw-bg-dt-surface-elevated tw-px-3 tw-py-2.5 tw-text-dt-text-headings tw-shadow-button"
        (click)="onFullPreviewClick()"
      >
        {{ "fullPreview" | i18n }}
      </button>
    </div>
  </div>

  @if (showFullPreview() && currentFile) {
    <app-file-full-preview
      [file]="currentFile"
      [fileName]="fileName"
      [mappedRows]="mappedRows"
      (closed)="closeFullPreview()"
    ></app-file-full-preview>
  }
</div>
